<template>
  <div>
    <Card>
      <tables ref="tables" editable v-model="tableData" :columns="columns"/>
      <Pager :total="this.total" @on-page-change="onPageChange"/>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import Pager from '_c/pager'
import { getLoginHistoryList } from '@/api/data'
export default {
  name: 'login_history_page',
  components: {
    Tables,
    Pager
  },
  data () {
    return {
      columns: [
        { title: 'IP', key: 'ip', sortable: false },
        { title: '地区', key: 'area', sortable: false },
        { title: '登陆时间', key: 'login_at', sortable: false },
        { title: '状态',
          key: 'expired',
          sortable: false,
          render (h, params) {
            return h('span', {
              style: (() => {
                if (params.row.expired) {
                  return { 'color': 'gray' }
                } else {
                  return { 'color': 'green' }
                }
              })(),
              attrs: { }
            }, (() => {
              if (params.row.expired) {
                return '已过期'
              } else {
                return '活跃'
              }
            })())
          }
        },
        { title: '客户端',
          key: 'user_agent',
          sortable: false,
          render (h, params) {
            return h('span', {
              style: {},
              attrs: { }
            }, (() => {
              if (params.row.user_agent !== '') {
                return params.row.user_agent
              } else {
                return 'unknown'
              }
            })())
          }
        }
      ],
      tableData: [],
      total: 0,
      page: 1
    }
  },
  methods: {
    onPageChange (page) {
      this.page = page
      getLoginHistoryList(page, 10).then(res => {
        if (res.data.ok) {
          console.log('list -->', res.data.list)
          this.tableData = res.data.list
          this.total = res.data.total
        }
      })
    }
  },
  mounted () {
    getLoginHistoryList(1, 10).then(res => {
      if (res.data.ok) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    })
  }
}
</script>
<style scoped>
</style>
